export * from './TypographyWithEllipsisTooltip';
